import React, { useState } from "react";
import "../MenuList/MenuList.css";
import "./ListaOrdenesPendiente.css";
export const DepositBank = ({
  bank,
  number_acount,
  type_acount,
  total_value,
  imageUrl,
  idDetalle
}) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploaded, setUploaded] = useState(false);
  const handleChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
    }
  };

  const handleUpload = async () => {
    if (!file) return alert("Por favor selecciona una imagen.");

    const formData = new FormData();
    formData.append("qr_code", file);
    formData.append("service_id", idDetalle);

    try {
      const res = await fetch("https://dev-api.menu.iguarayalabs.com/qr-code", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      alert("✅ Evidencia enviada correctamente");
      setUploaded(true);
      console.log(data);
    } catch (error) {
      console.error("❌ Error al subir:", error);
    }
  };


  return (
    <section >
      {!uploaded && (
        <div className="upload-container">
          <h3>📸 Sube tu evidencia de pago</h3>
          <p>Por favor sube una foto o captura del comprobante de tu transferencia.</p>

          <label htmlFor="file-upload" className="upload-label">
            {preview ? (
              <img src={preview} alt="Evidencia" className="preview-image" />
            ) : (
              <>
                <i className="fa fa-cloud-upload upload-icon"></i>
                <span>Haz clic o arrastra tu imagen aquí</span>
              </>
            )}
          </label>

          <input
            id="file-upload"
            type="file"
            accept="image/*"
            onChange={handleChange}
            hidden
          />

          <button onClick={handleUpload} className="upload-button">
            Enviar Evidencia
          </button>
        </div>
      )}



      <div className="container-orden-actual-detalle">
        <div className="element-info">
          <div className="container-info-orden">
            <p className="titulo">⚠️ ORDEN PENDIENTE DE PAGO</p>
          </div>

          <div className="container-info-orden">
            <p className="subtitulo">
              Por favor, proceda a realizar una transferencia utilizando los siguientes datos:
            </p>
          </div>
          <div >
            <div className="datos-transferencia">
              <p>Banco: <b>{bank}</b></p>
              <p>Cuenta #: <b>{number_acount}</b></p>
              <p>Tipo: <b>{type_acount}</b></p>
              <p>Valor: <b className="valor">{total_value}</b></p>

              {imageUrl && (
                <div className="imagen-comprobante">
                  <img src={imageUrl} alt="Comprobante o QR" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};
